import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/react-hooks';
import FormField from '../form/FormField';

const UserJobCategoryField = props => {

  let {
    businessType,
    onBlur,
    onChange,
    field,
    readOnly,
  } = props;

  const { loading, error, data, refetch } = useQuery(GET_TYPES, {
    variables: { businessType },
  });

  useEffect(() => {
    refetch({
      businessType,
    })
  }, [businessType])

  const _onBlur = (fieldName, value) => {
    if (onBlur) {
      onBlur(fieldName, value);
    }
  };

  const _onChange = (fieldName, value) => {
    if (onChange) {
      onChange(fieldName, value);
    }
  };

  const getOptions = (d) => {
    let types = d && d.viewer && d.viewer.jobCategoryTypes?d.viewer.jobCategoryTypes:[];
    return types.map(jobCategory => {
      return [jobCategory.name, jobCategory.label];
    })
  };

  if (error) console.error('UserJobCategoryField error', error)

  return (
    <FormField
      {...field}
      fieldName={'jobCategoryType'}
      options={loading||!businessType?[]:getOptions(data)}
      readOnly={readOnly}
      controlType={'select'}
      onBlur={_onBlur}
      onChange={_onChange}  />
  )

};

UserJobCategoryField.fragments = {
  jobCategoryTypes: gql`
      fragment UserJobCategoryField_jobCategoryTypes on JobCategoryType {
          id
          plainId
          name
          label
      }
  `
};

const GET_TYPES = gql`
    query getJobCategoryTypes($businessType: String) {
        viewer {
            id
            jobCategoryTypes(businessTypeName: $businessType) {
                id
                ...UserJobCategoryField_jobCategoryTypes
            }
        }
    }
  ${UserJobCategoryField.fragments.jobCategoryTypes}
`;

UserJobCategoryField.propTypes = {
  jobCategoryTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  businessType: PropTypes.string,
  readOnly: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

export default UserJobCategoryField;
